import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { TemplateProductForm } from './TemplateProductForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj szablon' : 'Dodaj szablon'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <TemplateProductForm
                data={data}
                submitCallback={submitCallback}
                handleClose={handleClose}
              />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
